import React from "react"
// import './InfluencerMarketing.css'
import monitoringTheDeviation from '../../assets/images/monitoringTheDeviation.webp'
import { Link } from "react-router-dom"


import influencerMarketingBanner from '../../assets/bannerImages/influencerMarketing.jpg'

import strategicPartnership from '../../assets/images/strategicPartnership.jpg'
import creativeExcellence from '../../assets/images/creativeExcellence.jpg'
import dataDrivenInsights from '../../assets/images/dataDrivenInsights.jpg'

import creativeCollaboration from '../../assets/images/strategicPlanning.jpg'
import performanceMeasurement from '../../assets/images/maximizedROI.jpg'

export default function InfluencerMarketing(){
    return(
        <div className="influencerMarketing">
            <IMR1/>
            <IMR2/>
            <IMR3/>
            <IMR4/>
            <ContactSection/>
            {/* this contact section's css is in social media marketing page's css file */}
        </div>
    )
}

function IMR1(){
    return(
        <div className='imr1'>
            <img loading="lazy" src={influencerMarketingBanner} alt='im-banner' className='im-banner-img'/>
            <h1 className='imr1-head'>Influencer Marketing</h1>
            <div className='overlay'></div>
        </div>
    )
}

function IMR2(){
    return(
        <div className='imr2'>
            <div className='strip'>
                <h1>What is <span>Influencer Marketing</span>?</h1>
                <hr/>   
                <p>Influencer marketing involves collaborating with influential individuals to promote products or services to their audience. It leverages the influence and reach of these individuals to create brand awareness, drive engagement, and ultimately increase sales.</p>
            </div>
        </div>
    )
}

function IMR3(){
    return(
        <div className='imr3'>
            <div className='rowThreeContainer'>
                <h1 className='rowThreeHead'>
                Why <span>Choose Bixian</span> for Influencer Marketing?
                </h1>
                <p className='rowThreeContext'>
                At Bixian, we understand the power of influencer marketing in today's digital landscape. Leveraging our expertise and industry insights, we offer tailored influencer marketing solutions to elevate your brand's presence and drive engagement.
                </p>
                <div className='rowThreeBoxes'>
                    {/* box 1 */}
                    <div className='box boxOne'>
                        <div className='context'>
                            <img loading="lazy" src={strategicPartnership} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Strategic Partnership
                            </h2>
                            <p className='boxPara'>
                            Bixian selects influencers aligned with your brand's goals and values, ensuring meaningful collaborations.
                            </p>
                        </div>
                    </div>
                    {/* box 2 */}
                    <div className='box boxTwo'>
                        <div className='context'>
                            <img loading="lazy" src={dataDrivenInsights} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Data-Driven Insights
                            </h2>
                            <p className='boxPara'>
                            Our analytics optimize performance, measuring engagement metrics for real-time strategy refinement.
                            </p>
                        </div>
                    </div>
                    {/* box 3 */}
                    <div className='box boxThree'>
                        <div className='context'>
                            <img loading="lazy" src={creativeExcellence} alt='boxImg' className='boxImg'/>
                            <h2 className='boxHead'>
                            Creative Excellence
                            </h2>
                            <p className='boxPara'>
                            Bixian fosters creativity in every collaboration, ensuring compelling content resonates with audiences.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

function IMR4(){
    return(
        <div className='imr4'>
            <div className='rowFourContainer'>
                <div className='rowFourContext'>
                    <h1 className='rowFourHead'>Our Process</h1>
                    <p className='rowFourPara'>
                    Harness the power of influencer marketing with Bixian's strategic approach. Connect with key influencers in your industry, leverage their authority, and amplify your brand's reach to engage and convert your target audience effectively.
                    </p>
                </div>
                <div className='rowFourBoxes'>
                    <div className='box boxOne'>
                            <img loading="lazy" src={monitoringTheDeviation} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Influencer Identification</h2>
                        <p className='boxPara'>We identify and vet influencers whose values, audience demographics, and content align with your brand, ensuring authentic and impactful partnerships.</p>
                    </div>
                    <div className='box boxTwo'>
                            <img loading="lazy" src={creativeCollaboration} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Creative Collaboration</h2>
                        <p className='boxPara'>Our team collaborates closely with influencers to develop compelling content that resonates with their audience while authentically showcasing your brand's values and offerings.</p>
                    </div>
                    <div className='box boxThree'>
                            <img loading="lazy" src={performanceMeasurement} alt='boxImg' className='boxImg'/>
                        <h2 className='boxHead'>Performance Measurement</h2>
                        <p className='boxPara'>Through comprehensive tracking and analytics, we measure the performance of influencer campaigns, analyzing engagement metrics, reach, and conversions to optimize future campaigns and maximize ROI.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

function ContactSection(){
    return(
        <div className="contactSection">
                <div className="box">
                    <div className="context">
                        <h1>Wanna Discuss More About Our Influencer Marketing?</h1>
                        <p>Schedule a free consultation and esitmate with our expert.</p>
                    </div>
                    <div className="buttonHolder">
                        <Link to='/contact'><button>Get A Free Estimation</button></Link>
                    </div>
                </div>
            </div>
    )
}